module.exports = __webpack_public_path__ + "img/listen-on-apple.73e95866.svg";